export default function PageMetaHelmet({ title, icon }) {
  return (
    <>
      {title && <title>{title}</title>}
      {icon && <link rel="icon" type="image/x-icon" href={icon} />}
    </>
  );
}
